// src/gameLogics/questionGenerator.js

const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export function generateQuestion(mode, level) {
    let num1, num2, operatorSymbol;

    if (mode === 'addition') {
        operatorSymbol = '+';
        if (level === 'beginner') { num1 = rand(1, 9); num2 = rand(1, 9); }
        if (level === 'amateur') { num1 = rand(1, 9); num2 = rand(10, 99); if(Math.random() > 0.5) [num1, num2] = [num2, num1]; }
        if (level === 'pro') { num1 = rand(10, 99); num2 = rand(10, 99); }
    } 
    else if (mode === 'subtraction') {
        operatorSymbol = '-';
        if (level === 'beginner') { num1 = rand(1, 9); num2 = rand(1, 9); }
        if (level === 'amateur') { num1 = rand(10, 99); num2 = rand(1, 9); if(Math.random() > 0.5) [num1, num2] = [num2, num1]; }
        if (level === 'pro') { num1 = rand(10, 99); num2 = rand(10, 99); }
    }
    else if (mode === 'multiplication') {
        operatorSymbol = '×';
        if (level === 'beginner') { num1 = rand(1, 9); num2 = rand(1, 9); }
        if (level === 'amateur') { num1 = rand(1, 9); num2 = rand(10, 50); }
        if (level === 'pro') { num1 = rand(10, 30); num2 = rand(10, 30); }
    }
    else if (mode === 'division') {
        operatorSymbol = '÷';
        if (level === 'beginner') { num2 = rand(1, 5); num1 = num2 * rand(1, 5); }
        if (level === 'amateur') { num2 = rand(2, 9); num1 = num2 * rand(5, 12); }
        if (level === 'pro') {
            num2 = rand(2, 10);
            num1 = Math.random() > 0.4 ? num2 * rand(5, 20) : rand(10, 99);
        }
    }

    const questionText = `${num1} ${operatorSymbol} ${num2}`;
    return questionText;
}

export function calculateAnswer(question) {
    const [num1, operator, num2] = question.split(' ');
    try {
        let result;
        switch (operator) {
            case '+': result = Number(num1) + Number(num2); break;
            case '-': result = Number(num1) - Number(num2); break;
            case '×': result = Number(num1) * Number(num2); break;
            case '÷': result = Number(num1) / Number(num2); break;
            default: throw new Error('Invalid operator');
        }
        return Math.round(result * 10) / 10; // Round to one decimal place
    } catch (e) {
        console.error("Calculation error:", e);
        return NaN;
    }
}